import type { ExtractDispatchFromModel, WidgetEffectParams } from '@swf/core/store';
import { integrationTesting } from '@swf/core/utils';
import type { GetUserClubsAndScheduledGamesResponse } from '@swf/generated/types/api/v0/SwHomeGames';
import type { GetLobbyInformationRequest } from '@swf/generated/types/api/v1-preview/SwHomeGames';
import type { HomeGamesWidgetModel } from '@swf/poker';
import { PKR_RETRY_INTERVALS } from '@swf/poker';

let attempts = 0;

export const fetchLobbyData = async (
  { polling }: { polling?: boolean },
  params: WidgetEffectParams<void>
) => {
  if (integrationTesting) return;

  const {
    request,
    dispatch,
    widget: { id }
  } = params;
  const widgetDispatch: ExtractDispatchFromModel<HomeGamesWidgetModel> = dispatch[id];

  try {
    const { body } = await request<GetUserClubsAndScheduledGamesResponse>({
      service: '/api/v1-preview/homegames/lobby',
      body: { polling } as GetLobbyInformationRequest
    });
    const { success, clubInfoList, filteredClubInfoReply } = body;

    if (success && clubInfoList && filteredClubInfoReply) {
      widgetDispatch.setUserClubsAndGames(body);
      widgetDispatch.setError({ level: 'critical', value: false });
    }
  } catch (error) {
    if (attempts >= PKR_RETRY_INTERVALS.length) {
      widgetDispatch.setError({ level: 'critical', value: true });

      return;
    }

    setTimeout(() => {
      fetchLobbyData({ polling }, params);
      attempts++;
    }, PKR_RETRY_INTERVALS[attempts]);
  }
};
